<template>
  <v-container
    id="contas-pagar-form"
    fluid
    tag="section"
  >
    <!-- FORMULARIO DE USUARIO NAO IDENTIFICADO -->
    <usuario-nao-identificado-form
      v-if="!usuarioIdentificado"
      :titulocard="$t('contas-a-pagar')"
    />

    <base-material-card
      v-else
      color="primary"
      icon="mdi-bank-transfer-out"
      :title="$t('contas-a-pagar')"
      :app-online="appOnline"
    >
      <v-row>
        <v-col
          cols="12"
          lg="12"
        >
          <v-skeleton-loader
            v-if="loading_laticinios"
            type="table-heading, table-tbody, table-tfoot"
          />
          <div v-else>
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent="pesquisar(laticinio.select.id, new Date(parseDate('01/' + dataPesquisa)).toISOString().substr(0, 10))"
            >
              <v-row>
                <v-col
                  cols="12"
                  lg="8"
                >
                  <v-select
                    v-model="laticinio.select"
                    label="Laticínio"
                    :items="laticinio.items"
                    item-text="nome"
                    item-value="id"
                    :success="true"
                    :disabled="disabledSelectLaticinio"
                    persistent-hint
                    return-object
                    @change="onChange($event)"
                  />
                </v-col>
                <v-col
                  cols="12"
                  lg="4"
                >
                  <v-menu
                    ref="menuData"
                    v-model="menuData"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dataPesquisa"
                        v-mask="maskDataPesquisa"
                        :rules="dataPesquisaRules"
                        :disabled="disabledSelectDate"
                        :success="true"
                        label="Mês de Vencimento"
                        @blur="date = parseDate('01/' + dataPesquisa)"
                        v-on="on"
                      >
                        <template
                          v-if="true"
                          v-slot:append-outer
                        >
                          <v-btn
                            :disabled="!valid"
                            class="mt-n2"
                            elevation="1"
                            fab
                            small
                            color="primary"
                            type="submit"
                          >
                            <v-icon>mdi-magnify</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      type="month"
                      no-title
                      @input="menuData = false"
                    />
                  </v-menu>
                </v-col>
              </v-row>
              <v-skeleton-loader
                v-if="loading_contas"
                height="250"
                type="table-tbody"
              />
              <!-- TABELA -->
              <v-data-table
                v-else
                :headers="titulosListaContasPagar"
                :items="listaContasPagar"
                :items-per-page="5"
                class="elevation-1"
                disable-pagination
                hide-default-footer
                disable-sort
              >
                <!-- Formatacao dos campos em tela de tela grande/navegador-->
                <template
                  v-if="!$vuetify.breakpoint.xs"
                  v-slot:item="props"
                >
                  <tr :class="{'quitado': props.item.quitado}">
                    <td>
                      {{ formatDiaMesAno(props.item.vencimentoparcela) }}
                    </td>
                    <td>
                      {{ formatDiaMesAno(props.item.dataemissao) }}
                    </td>
                    <td>
                      {{ parseMoeda(props.item.total,2) }}
                    </td>
                    <td>
                      {{ parseMoeda(props.item.valorreceber,2) }}
                    </td>
                    <td>
                      {{ parseMoeda(props.item.valorrecebido,2) }}
                    </td>
                    <td>
                      {{ props.item.numeronota + ((props.item.numeronota === null) ? props.item.numeroparcela : ('/' + props.item.numeroparcela)) }}
                    </td>
                  </tr>
                </template>

                <!-- Formatacao dos campos em tela de celular-->
                <template
                  v-if="$vuetify.breakpoint.xs"
                  v-slot:[`item.vencimentoparcela`]="{ item }"
                >
                  <label>
                    {{ formatDiaMesAno(item.vencimentoparcela) }}
                  </label>
                </template>
                <template
                  v-if="$vuetify.breakpoint.xs"
                  v-slot:[`item.dataemissao`]="{ item }"
                >
                  <label>
                    {{ formatDiaMesAno(item.dataemissao) }}
                  </label>
                </template>
                <template
                  v-if="$vuetify.breakpoint.xs"
                  v-slot:[`item.total`]="{ item }"
                >
                  <label>
                    {{ parseMoeda(item.total,2) }}
                  </label>
                </template>
                <template
                  v-if="$vuetify.breakpoint.xs"
                  v-slot:[`item.valorrecebido`]="{ item }"
                >
                  <label>
                    {{ parseMoeda(item.valorrecebido,2) }}
                  </label>
                </template>
                <template
                  v-if="$vuetify.breakpoint.xs"
                  v-slot:[`item.valorreceber`]="{ item }"
                >
                  <label>
                    {{ parseMoeda(item.valorreceber,2) }}
                  </label>
                </template>
                <template
                  v-if="$vuetify.breakpoint.xs"
                  v-slot:[`item.numeronota`]="{ item }"
                >
                  <label>
                    {{ item.numeronota + ((item.numeronota === null) ? item.numeroparcela : ('/' + item.numeroparcela)) }}
                  </label>
                </template>
                <!-- rodape celular-->
                <template
                  v-if="$vuetify.breakpoint.xs"
                  v-slot:[`body.append`]
                >
                  <tr class="totalizador">
                    <td>
                      <strong>Total Quitado: </strong>{{ parseMoeda(somavalorpago,2) }}
                    </td>
                  </tr>
                  <tr class="totalizador">
                    <td>
                      <strong>Total Em Aberto: </strong>{{ parseMoeda(somavalorpagar,2) }}
                    </td>
                  </tr>
                </template>
                <!-- rodape navegador-->
                <template
                  v-else
                  v-slot:[`body.append`]
                >
                  <tr
                    class="totalizador"
                  >
                    <td
                      colspan="3"
                    />
                    <td>
                      <strong>{{ parseMoeda(somavalorpagar,2) }}</strong>
                    </td>
                    <td>
                      <strong>{{ parseMoeda(somavalorpago,2) }}</strong>
                    </td>
                    <td />
                  </tr>
                </template>
              </v-data-table>
              <v-footer>
                <v-row>
                  <v-col
                    cols="12"
                    lg="12"
                  >
                    <div class="text-right">
                      Total a pagar em aberto no período: <span class="font-weight-bold">R$ {{ parseMoeda(soma_pagar_menos_pago,2) }}</span>
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="12"
                  >
                    <v-badge
                      v-if="exibeRodapeEmAberto"
                      :content="qtdeEmAberto"
                      :value="qtdeEmAberto"
                      color="grey"
                      left
                      overlap
                      inline
                    >
                      Quitar
                    </v-badge>
                    <v-badge
                      v-if="exibeRodapeCancelada"
                      :content="qtdeCancelada"
                      :value="qtdeCancelada"
                      color="red"
                      left
                      overlap
                      inline
                    >
                      Cancelada(s)
                    </v-badge>
                    <v-badge
                      v-if="exibeRodapeQuitada"
                      :content="qtdeQuitada"
                      :value="qtdeQuitada"
                      color="green"
                      left
                      overlap
                      inline
                    >
                      Quitada(s)
                    </v-badge>
                  </v-col>
                </v-row>
              </v-footer>
            </v-form>
          </div>
        </v-col>
        <dashboard-core-snackbar
          v-model="snackbar.visible"
          :visible="snackbar.visible"
          :timeout="snackbar.timeout"
          :color="snackbar.color"
          :message="snackbar.message"
        />
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
  import ContasReceberService from '../../../services/contasreceberservice'
  import utils from '../../../services/utils'

  export default {
    name: 'DashboardFormsContasPagarForm',
    components: {
      DashboardCoreSnackbar: () => import('../components/core/Snackbar'),
      UsuarioNaoIdentificadoForm: () => import('./UsuarioNaoIdentificadoForm'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      usuarioIdentificado: true,
      valid: true,
      disabledSelectLaticinio: false,
      disabledSelectDate: false,
      date: new Date().toISOString().substr(0, 10),
      dataPesquisa: '',
      maskDataPesquisa: '##/####',
      dataPesquisaRules: [
        v => /^\d{2}\/\d{4}$/.test(v),
      ],
      menuData: false,
      listaContasPagar: [],
      titulosListaContasPagar: [
        { text: 'Vencimento', sortable: true, value: 'vencimentoparcela' },
        {
          text: 'Emissão',
          align: 'start',
          sortable: true,
          value: 'dataemissao',
        },
        { text: 'Total', sortable: true, value: 'total' },
        { text: 'Em Aberto', sortable: true, value: 'valorreceber' },
        { text: 'Quitado', sortable: true, value: 'valorrecebido' },
        { text: 'Nº Nota/Parc.', sortable: true, value: 'numeronota' },
      ],
      somavalorpagar: '',
      somavalorpago: '',
      somaabatimento: '',
      somatotal: '',
      soma_pagar_menos_pago: '',
      qtdeCancelada: 0,
      exibeRodapeCancelada: false,
      qtdeQuitada: 0,
      exibeRodapeQuitada: false,
      qtdeEmAberto: 0,
      exibeRodapeEmAberto: false,
      laticinio: {
        label: 'Laticínio',
        select: { id: 0, nome: 'Nenhuma informação encontrada' },
        items: [
          { id: 0, nome: 'Nenhuma informação encontrada' },
        ],
        totalQtde: 0,
      },
      user: {
        username: '',
        roles: '["ROLE_PRODUTOR"]',
        password: '',
      },
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      loading_laticinios: false,
      loading_contas: false,
    }),

    watch: {
      date (val) {
        this.dataPesquisa = this.formatDate(val)
      },
    },

    mounted () {
      if (localStorage.chaveativacao && localStorage.chaveativacao !== 'undefined') {
        this.chaveativacao = localStorage.chaveativacao
        if (localStorage.getItem('usuarioIdentificado') && localStorage.getItem('usuarioIdentificado') === 'true') {
          this.usuarioIdentificado = true
          this.carregaForm()
        } else {
          this.usuarioIdentificado = false
        }
      } else {
        localStorage.clear()
        this.$router.push('/')
      }
    },
    methods: {
      async carregaForm () {
        this.dataPesquisa = this.formatDate(this.date)
        await this.carregaLaticinios()

        if (this.laticinio.items.length > 0) {
          this.laticinio.select = this.laticinio.items[0].id
        }
      },

      pesquisar (idLaticinio, dataFiltro) {
        var mes = dataFiltro.substring(5, 7)
        var ano = dataFiltro.substring(0, 4)

        if (this.laticinio.items.length > 0) {
          if ((this.laticinio.items[0].id > 0) && (this.laticinio.select === null || this.laticinio.select.id === 0)) {
            this.laticinio.select = this.laticinio.items[0]
            idLaticinio = this.laticinio.select.id
          }
        }

        if (idLaticinio === -1) {
          this.carregaLaticinios(mes, ano)
        } else if (idLaticinio === 0) {
          this.showSnackbar('warning', 3000, 'Selecione um laticínio antes de pesquisar.')
        } else {
          var laticinio = this.laticinio.items.find(item => item.id === idLaticinio)
          this.loading_contas = true
          this.carregaContasPagar(laticinio.id, laticinio.produtor_id, mes, ano)
        }
      },

      carregaLaticinios (mes, ano) {
        this.loading_laticinios = true

        ContasReceberService.listarLaticinios(localStorage.chaveativacao).then(resposta => {
          if (resposta.data.empresas.length > 0) {
            this.laticinio.items = resposta.data.empresas
            this.laticinio.select = resposta.data.empresas[0]

            // var idProdutor = resposta.data.empresas[0].produtor_id

            if (resposta.data.empresas.length === 1) {
              this.laticinio.select = resposta.data.empresas[0]

              this.laticinio.label = resposta.data.empresas[0].nome

              this.disabledSelectLaticinio = true

              this.pesquisar(resposta.data.empresas[0].id, this.date)
            }
          }

          this.verificaVersao(resposta.data.versao_vue)
          this.loading_laticinios = false
          this.disabledSelectDate = false
          this.appOnline = true
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.carregaDadosOffline()
          } else {
            console.error('Erro listarLaticinios(): ', JSON.stringify(e.response))
            this.$router.push('/')
          }
          this.loading_laticinios = false
        })
      },

      carregaContasPagar (idLaticinio, idProdutor, mes, ano) {
        ContasReceberService.listar(idLaticinio, idProdutor, mes, ano).then(resposta => {
          this.listaContasPagar = resposta.data.contas

          this.calculaTotal()
          if (this.listaContasPagar.length > 0) {
            this.salvaDadosOffline()
          }
          this.appOnline = true
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.carregaDadosOffline()
          } else {
            console.error('Erro listar(): ', JSON.stringify(e.data))
            this.$router.push('/')
          }
          this.loading_contas = false
        })
      },

      onChange (event) {
        this.laticinio.select = event
        // this.idLaticinio = this.laticinio.select.id
        this.pesquisar(this.laticinio.select.id, this.date)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      calculaTotal () {
        this.somavalorpagar = this.listaContasPagar.reduce((soma, item) => !item.cancelada ? (soma + item.valorreceber) : soma, 0)
        this.somavalorpago = this.listaContasPagar.reduce((soma, item) => !item.cancelada ? (soma + item.valorrecebido) : soma, 0)
        this.soma_pagar_menos_pago = this.somavalorpagar - this.somavalorpago
        this.laticinio.totalQtde = this.listaContasPagar.reduce((soma, item) => soma + item.total, 0)
        this.ajustaRodapeEmAberto()
        this.ajustaRodapeCancelada()
        this.ajustaRodapeQuitada()
        this.loading_contas = false
      },

      ajustaRodapeEmAberto () {
        this.qtdeEmAberto = this.listaContasPagar.reduce((soma, item) => (!item.cancelada && !item.quitadoparcela) ? (soma + 1) : soma, 0)
        if (this.qtdeEmAberto > 0) {
          this.exibeRodapeEmAberto = true
        } else {
          this.exibeRodapeEmAberto = false
        }
      },

      ajustaRodapeCancelada () {
        this.qtdeCancelada = this.listaContasPagar.reduce((soma, item) => item.cancelada ? (soma + 1) : soma, 0)
        if (this.qtdeCancelada > 0) {
          this.exibeRodapeCancelada = true
        } else {
          this.exibeRodapeCancelada = false
        }
      },

      ajustaRodapeQuitada () {
        this.qtdeQuitada = this.listaContasPagar.reduce((soma, item) => item.quitadoparcela ? (soma + 1) : soma, 0)
        if (this.qtdeQuitada > 0) {
          this.exibeRodapeQuitada = true
        } else {
          this.exibeRodapeQuitada = false
        }
      },

      salvaDadosOffline () {
        try {
          localStorage.laticinioSelecionadoContasPagarLabel = this.laticinio.select.nome
          localStorage.mesSelecionadoContasPagar = this.date
          const parsed = JSON.stringify(this.listaContasPagar)
          localStorage.setItem('listaContasPagar', parsed)
        } catch (e) {
        }
      },

      carregaDadosOffline () {
        this.appOnline = false
        this.laticinio.label = localStorage.laticinioSelecionadoContasPagarLabel
        this.date = localStorage.mesSelecionadoContasPagar
        this.disabledSelectLaticinio = true
        this.disabledSelectDate = true
        if (localStorage.getItem('listaContasPagar')) {
          try {
            this.listaContasPagar = JSON.parse(localStorage.getItem('listaContasPagar'))
            this.calculaTotal()
          } catch (e) {
            localStorage.removeItem('listaContasPagar')
          }
        }
      },
    },
  }
</script>

<style scoped>
  .quitado { color: green; }
  .cancelado { color: red; }
  .totalizador { background-color: rgba(78, 119, 173, 0.2);}
  /* .totalizador td { font-weight: 500;} */
  .v-data-table table thead tr th {font-weight: 400;}
  .theme--light.v-label {
    color: rgba(0, 0, 0, 0.9);
  }
</style>
